import type { ComponentPropsWithoutRef } from 'react'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { ContentSection } from '@/scopes/common/components/Footer/ContentSection'
import FooterContainer from '@/scopes/common/components/Footer/FooterContainer'
import LegalMenuBar from '@/scopes/common/components/Footer/LegalMenuBar'
import PartnersBar from '@/scopes/common/components/Footer/PartnersBar'
import { shouldShowFooterLegalDisclaimer } from '@/scopes/common/domain/policies/siteName'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { Block, Header } from './Blocks'
import styles from './Footer.module.css'
import { FooterList as List, FooterListItem as ListItem } from './List'

function Footer({ children, ...attrs }: ComponentPropsWithoutRef<'footer'>) {
  const intl = useIntl()
  const siteName = useConfiguration('siteName')

  return (
    <FooterContainer {...attrs}>
      {/* This content can differ per page */}
      <ContentSection>{children}</ContentSection>

      {children && <div className={styles.line} />}

      <PartnersBar />

      {shouldShowFooterLegalDisclaimer(siteName) && (
        <>
          <div className={styles.line} />
          <section>
            <Typography variant="body-m-regular-tight">
              {intl.formatMessage({ id: 'footer_legal_disclaimer' })}
            </Typography>
          </section>
        </>
      )}
      <div className={styles.line} />
      <LegalMenuBar />
    </FooterContainer>
  )
}

export default Object.assign(Footer, { Block, Header, ListItem, List })
